export const API_URL = import.meta.env.VITE_API_URL;
export const SITE_URL = import.meta.env.VITE_SITE_URL;
export const YANDEX_METRIKA_ID = import.meta.env.VITE_YANDEX_METRIKA_ID
export const PIXEL_ID = import.meta.env.VITE_PIXEL_ID
export const ADRIVER_ID = import.meta.env.VITE_ADRIVER_ID
export const textStartEnd = 'с 1 декабря 2025 г. по 31 января 2026 г.';
